import type { WGuestCollectionDetailView } from '@zola/svc-web-api-ts-client';

import ConfigureAddressCollectionFormValues from 'components/manage/guestlist/addressCollection/@types/formValues';

export type GuestCollectionSubmission = WGuestCollectionDetailView & {
  wedding_date?: string;
};

export const mapGuestCollectionToFormValues = (
  guestCollection?: WGuestCollectionDetailView | null
): ConfigureAddressCollectionFormValues => ({
  linkTitle: guestCollection?.link_title,
  showWeddingDate: guestCollection?.show_wedding_date,
});

export const mapFormValuesToGuestCollection = ({
  linkTitle,
  imageUuid,
  weddingDate,
  showWeddingDate = false,
}: ConfigureAddressCollectionFormValues): GuestCollectionSubmission => ({
  link_title: linkTitle,
  image_uuid: imageUuid,
  show_wedding_date: showWeddingDate,
  wedding_date: weddingDate,
});

export default {
  mapGuestCollectionToFormValues,
  mapFormValuesToGuestCollection,
};



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/helpers/mapper.ts